import { TFunction } from 'i18next';
import { RouteTimelineDtoModelType } from '../../../../../../store/mst/models';

export const getEventTimeLabel = (
  event: RouteTimelineDtoModelType,
  t: TFunction,
): string => {
  if (event.isDeparted) return t('components:routeDetailsPanel.stats.labels.departed');
  if (event.isArrived) return t('components:routeDetailsPanel.stats.labels.arrived');
  return t('components:routeDetailsPanel.stats.labels.eta');
};
